import React from 'react';
import Contacto from '../components/Contacto/Contacto';

export default function ContactoPage() {
  return (
    <div>
      <Contacto />
    </div>
  );
}